<div class="learning-section-container-single-edit-dialog">
    <div
        class="close-modal"
        (click)="onCancel()"
        (keydown.escape)="onCancel()"
        tabindex="0"
    >
        <mat-icon>close</mat-icon>
    </div>
    <h1 mat-dialog-title>Container editieren</h1>
    <mat-divider></mat-divider>
    <mat-dialog-content class="grid">
        <form [formGroup]="formGroup">
            <div class="form-fields">
                <mat-form-field class="form-field">
                    <mat-label>Titel</mat-label>
                    <input
                        matInput
                        type="text"
                        placeholder=""
                        formControlName="title"
                        required
                    />
                    <mat-error>{{ checkForErrors(formGroup.controls["title"]) }} </mat-error>
                </mat-form-field>

                @if (data.content) {
                    <mat-card appearance="outlined" class="selected-content" style="margin-bottom: 1rem; background-color: #f5f5f5;">
                        <mat-card-content>
                            <div style="display: flex; flex-direction: column; gap: 4px;">
                                <div style="font-size: 1.1rem; margin-top: 4px;">
                                    Aktuell gespeicherter Inhalt:
                                </div>
                                <div>
                                    <mat-chip-listbox>
                                        <mat-chip highlighted disabled style="opacity: 1 !important;">
                                            {{ getContentTypeLabel(contentRef?.type) }}
                                        </mat-chip>
                                        <mat-chip highlighted disabled style="opacity: 1 !important;">
                                            {{ originalSavedName }}
                                        </mat-chip>
                                    </mat-chip-listbox>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                }

                <div class="learning-section-container-content-options">
                    <mat-slide-toggle
                            formControlName="fullWidth"
                            labelPosition="before"
                            class="slide-toggler"
                    >{{ 'learningSectionContainer.field.fullWidth' | transloco }} </mat-slide-toggle>

                </div>
            </div>
        </form>

        <div class="my-3"></div>

        <mat-card appearance="outlined">
            <mat-tab-group
                (selectedTabChange)="onTabChange($event)"
                [(selectedIndex)]="activeTabIndex"
                class="container-content-tab-group"
            >
                <mat-tab
                    label="editor"
                    [disabled]="isTabLocked('editor')"
                >
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">ink_pen</mat-icon>
                        <span>Pixl-Inhalt</span>
                    </ng-template>

                    <div class="tab-content">
                        <mat-form-field>
                            <mat-label>PIXL-Content Suche</mat-label>
                            <input
                                    matInput
                                    type="text"
                                    [(ngModel)]="searchTerm"
                                    name="explanationContentSearch"
                                    (blur)="explanationContentLoader.search(searchTerm)"
                            />
                            @if (searchTerm) {
                                <button
                                        matSuffix
                                        mat-icon-button
                                        aria-label="Clear"
                                        (click)="searchTerm = ''"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            }
                        </mat-form-field>

                        @if (!(explanationContentLoader.entities$ | async)?.length && !missingEntitySelection) {
                            <pixl-table-loading-spinner [name]="'PIXL-Inhalte'" />
                        } @else {
                            @if (explanationContentLoader.entities$ | async; as contents) {
                                <mat-form-field style="width: 100%">
                                    <mat-label>PIXL-Inhalte</mat-label>
                                    <mat-select
                                        #explanationContentSelect
                                        [(ngModel)]="selectedContent"
                                        [compareWith]="compareContentById"
                                        placeholder="explanationContentSelect"
                                        (closed)="onEditorSelectClosed()"
                                        (openedChange)="onSelectOpened($event, explanationContentLoader, explanationContentSelect)"
                                    >
                                        @if (missingEntitySelection && selectedTabLabel === 'editor') {
                                            <mat-option [value]="missingEntitySelection" style="display: none;">
                                                {{ missingEntitySelection.name }}
                                            </mat-option>
                                        }

                                        @for (content of contents; track content.id) {
                                            <mat-option [value]="content">{{ content.name }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }
                        }

                        <div class="py-2"></div>

                        <mat-form-field
                            class="form-field"
                            style="width: 50%"
                        >
                            <mat-label>Name</mat-label>
                            <input
                                matInput
                                [formControl]="explanationContentName"
                                type="text"
                                placeholder=""
                                required
                            />
                            @if (explanationContentName.hasError("required")) {
                            <mat-error>Dies ist ein Pflichtfeld.</mat-error>
                            }
                            @if (explanationContentName.hasError("unique")) {
                            <mat-error>Der Name wird bereits verwendet.</mat-error>
                            }
                        </mat-form-field>

                        @if (!this.checkNewEditorContent()) {
                            <span class="px-2"></span>

                            <button
                                    mat-raised-button
                                    color="primary"
                                    (click)="onCopy()"
                            >Kopie erstellen</button>
                        }

                        <pixl-editor
                            [htmlString]="explanationContentHtml"
                            [editorHeight]="'auto'"
                            [bearerToken]="authToken!"
                            [assetUrl]="assetsUrl"
                            [mediaUrl]="mediaUrl"
                            [(editedHtmlString)]="explanationContentHtml"
                        >
                        </pixl-editor>
                    </div>
                </mat-tab>
                <mat-tab
                        label="sequence"
                        [disabled]="isTabLocked('sequence')"
                >
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">link</mat-icon>
                        <span> Lernsequenz</span>
                    </ng-template>

                    <div class="tab-content">
                        <mat-form-field>
                            <mat-label>Lernsequenz Suche</mat-label>
                            <input
                                    matInput
                                    type="text"
                                    [(ngModel)]="searchTerm"
                                    name="sequenceSearch"
                                    (blur)="sequenceLoader.search(searchTerm)"
                            />
                            @if (searchTerm) {
                                <button
                                        matSuffix
                                        mat-icon-button
                                        aria-label="Clear"
                                        (click)="searchTerm = ''"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            }
                        </mat-form-field>

                        @if (!(sequenceLoader.entities$ | async)?.length && !missingEntitySelection) {
                            <pixl-table-loading-spinner [name]="'Sequenzen'" />
                        }
                        @else {
                            @if (sequenceLoader.entities$ | async; as sequences) {
                                <mat-form-field style="width: 100%">
                                    <mat-label>Lernsequenzen</mat-label>
                                    <mat-select
                                        #sequenceSelect
                                        [(ngModel)]="selectedContent"
                                        [compareWith]="compareContentById"
                                        placeholder="sequenceSelect"
                                        (openedChange)="onSelectOpened($event, sequenceLoader, sequenceSelect)"
                                    >
                                        @if (missingEntitySelection && selectedTabLabel === 'sequence') {
                                            <mat-option [value]="missingEntitySelection" style="display: none;">
                                                {{ missingEntitySelection.name }}
                                            </mat-option>
                                        }

                                        @for (sequence of sequences; track sequence.id) {
                                            <mat-option [value]="sequence">{{ sequence.name }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }
                        }
                    </div>
                </mat-tab>
                @if (showExplanationTab) {
                    <mat-tab
                    label="explanation"
                    [disabled]="isTabLocked('explanation')"
                >
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">link</mat-icon>
                        <span>Erkläreinheit</span>
                    </ng-template>

                    <div class="tab-content">
                        <mat-form-field>
                            <mat-label>Erkläreinheit Suche</mat-label>
                            <input
                                    matInput
                                    type="text"
                                    [(ngModel)]="searchTerm"
                                    name="explanationSearch"
                                    (blur)="explanationLoader.search(searchTerm)"
                            />
                            @if (searchTerm) {
                                <button
                                        matSuffix
                                        mat-icon-button
                                        aria-label="Clear"
                                        (click)="searchTerm = ''"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            }
                        </mat-form-field>
                        @if (!(explanationLoader.entities$ | async)?.length) {
                            <pixl-table-loading-spinner [name]="'Erkläreinheiten'" />
                        } @else {
                            @if (explanationLoader.entities$ | async; as explanations) {
                                <mat-form-field style="width: 100%">
                                    <mat-label>Erkläreinheiten</mat-label>
                                    <mat-select
                                        #explanationSelect
                                        [(ngModel)]="selectedContent"
                                        [compareWith]="compareContentById"
                                        placeholder="explanationSelect"
                                        (openedChange)="onSelectOpened($event, explanationLoader, explanationSelect)"
                                    >
                                        @for (explanation of explanations; track explanation.id) {
                                            <mat-option [value]="explanation">{{ explanation.name }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }
                        }
                    </div>
                </mat-tab>
                }
                <mat-tab
                        label="test"
                        [disabled]="isTabLocked('test')"
                >
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">link</mat-icon>
                        <span>Test</span>
                    </ng-template>

                    <div class="tab-content">
                        <mat-form-field>
                            <mat-label>Test Suche</mat-label>
                            <input
                                    matInput
                                    type="text"
                                    [(ngModel)]="searchTerm"
                                    name="testSearch"
                                    (blur)="testLoader.search(searchTerm)"
                            />
                            @if (searchTerm) {
                                <button
                                        matSuffix
                                        mat-icon-button
                                        aria-label="Clear"
                                        (click)="searchTerm = ''"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            }
                        </mat-form-field>

                        @if (!(testLoader.entities$ | async)?.length && !missingEntitySelection) {
                            <pixl-table-loading-spinner [name]="'Tests'" />
                        } @else {
                            @if (testLoader.entities$ | async; as tests) {
                                <mat-form-field style="width: 100%">
                                    <mat-label>Tests</mat-label>
                                    <mat-select
                                        #testSelect
                                        [(ngModel)]="selectedContent"
                                        [compareWith]="compareContentById"
                                        placeholder="testSelect"
                                        (openedChange)="onSelectOpened($event, testLoader, testSelect)"
                                    >
                                        @if (missingEntitySelection && selectedTabLabel === 'test') {
                                            <mat-option [value]="missingEntitySelection" style="display: none;">
                                                {{ missingEntitySelection.name }}
                                            </mat-option>
                                        }

                                        @for (test of tests; track test.id) {
                                            <mat-option [value]="test">{{ test.name }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }
                        }
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card>

        <div class="my-4"></div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <div
        mat-dialog-actions
        align="end"
    >
        <button
            mat-raised-button
            color="primary"
            (click)="onSave()"
        >Speichern</button>
        <button
            mat-raised-button
            color="primary"
            (click)="onClose()"
        >Schließen</button>
    </div>
</div>